import React, { FC, useEffect, useState, useRef } from "react";
import { saveNotificationApi } from "./Notification.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "context/auth-context";
import logo from "../../../assets/zampLogo.png";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
export interface ICard {
  pointBalance?: any;
  getNotificationCount?: any;
  setNotificationCount?: any;
  notificationCount?: number;
}

export const PointNotificationModel: FC<ICard> = ({
  pointBalance,
  setNotificationCount,
  notificationCount,
}) => {
  const { auth } = useAuth();
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [message, setMessage] = useState("");
  const modalRef = useRef<HTMLDivElement>(null);
  const queryClient = useQueryClient();
  const type = "point";

  const mutation = useMutation(() => saveNotificationApi(auth?.panelistId, message, type), {
    onSuccess: (response: any) => {
      if (response.success) {
        queryClient.invalidateQueries(["saveNotificationApi"]);
      }
    },
    onError: () => {
      toast.error(t("point.notification.saving"));
    },
  });

  const handleModalClose = () => {
    mutation.mutate();
    setNotificationCount(notificationCount + 1);
    setIsModalVisible(false);
  };

  // Alert logic with localStorage
  useEffect(() => {
    const today = new Date();
    const day = today.getDay();
    const todayDateKey = today.toDateString();
    const hasShownModalDate = localStorage.getItem("pointModelShown");

    if ((day === 1 || day === 4) && hasShownModalDate !== todayDateKey) {
      let message = "";

      if (pointBalance === 0) {
        message = t("page.notification.start");
      } else if (pointBalance > 0 && pointBalance <= 500) {
        message = `${t("page.notification.Great")} ${pointBalance} ${t("page.notification.starKeept")}`;
      } else if (pointBalance > 500 && pointBalance <= 1500) {
        message = `${t("page.notification.fire")} ${pointBalance} ${t("page.notification.counting")}`;
      } else if (pointBalance > 1500 && pointBalance < 2500) {
        message = `${t("page.notification.Impressive")} ${pointBalance} ${t("page.notification.re")}`;
      } else if (pointBalance >= 2500 && pointBalance < 3000) {
        message = `${t("page.notification.Almost")} ${3000 - pointBalance} ${t("page.notification.away")}`;
      } else if (pointBalance >= 3000) {
        message = `${t("page.notification.Achievement")} ${pointBalance} ${t("page.notification.redeem")}`;
      }

      if (message) {
        const sendNotification = localStorage.getItem("sendNotification");
        if (sendNotification) {
          setMessage(message);
          setIsModalVisible(true);
          localStorage.setItem("pointModelShown", todayDateKey);

        }
      }
    }
  }, [pointBalance]);

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        handleModalClose();
      }
    };

    if (isModalVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isModalVisible]);

  return (
    <div>
      {isModalVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex justify-center font-poppins">
          {/* Modal Content */}
          <div
            ref={modalRef}
            className="relative w-[90%] sm:w-[60%] lg:w-[40%] 2xl:w-[30%] h-40 bg-white shadow-lg rounded-3xl p-4 z-50 font-poppins top-28"
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-4 py-4 px-6 sm:mt-3 2xl:mt-4">
                <img
                  src={logo}
                  alt="Reward Icon"
                  className="bg-[#056E9C1A] bg-opacity-10 rounded-md p-2"
                />
                <p className="text-base text-[#000000]">{message}</p>
              </div>
              <button onClick={handleModalClose} className="text-xl absolute right-4 top-4">
                X
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
